/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit Password.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import * as fromData from 'Data/ViewsData.js'
import Info from 'DesignSystem/Info/view.js'
import InputPassword from 'DesignSystem/InputPassword/logic.js'
import React from 'react'
import useIsMedia from 'Logic/useIsMedia.js'
InputPassword.displayName = 'InputPasswordLogic'



export default function Password({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  isInvalid,
onChange,
onSubmit,
value,
viewPath= "/App/Auth/SignInNewPasswordRequired/Password"
}) {
    
    
    let isMedia = useIsMedia()
    
    let data = fromData.useData({ viewPath, path: 'signin_new_password_required.password', 
context: 'signin_new_password_required',
validate: 'password',
validateRequired: true,
})
    

  return (<React.Fragment
>
<InputPassword
 data-testid="Password.InputPassword"
 data-view-path="/App/Auth/SignInNewPasswordRequired/Password"
viewPath={`${viewPath}/InputPassword`}
 autoFocus={true}
 marginTop={20}
 marginRight={0}
 marginLeftLabel={0}
 paddingBottom={16}
 paddingLeft={16}
 paddingRight={16}
 paddingTop={16}
 isInvalid={data.isInvalid}
 label="password"
 onChange={data.onChange}
 onSubmit={data.onSubmit}
 placeholder="Create new password"
 textTransform="none"
 type="password"
 value={data.value}
 width="100%"
/>
<Info
 data-testid="Password.Info"
 data-view-path="/App/Auth/SignInNewPasswordRequired/Password"
viewPath={`${viewPath}/Info`}
 text="Min: 8 characters, one number, one capital letter, one special character !@&"
 fontSize={isMedia.mobile ? "12px" : "10px"}
 marginTop={isMedia.mobile ? "6px" : "2px"}
 whiteSpace="wrap"
/>
{children}
</React.Fragment>)
}